import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CitaService } from 'src/app/core/services/cita.service';

@Component({
  selector: 'app-tuespecialista',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './tuespecialista.component.html',
  styleUrl: './tuespecialista.component.scss'
})
export class TuespecialistaComponent implements OnInit {
  currentUser: any;
  nombreEspecialista:string;
  idEspecialista:string;


  constructor(
    private __citasservice: CitaService,
    private router: Router,
    private route: ActivatedRoute,

  ) {
    
  }

    ngOnInit() {
      const currentUser = localStorage.getItem('currentPatient');
      if (currentUser) {
        this.currentUser = JSON.parse(currentUser);
        this.getEspecialista(this.currentUser.userId);
      }else{
        // NO HA INICIADO SESISIÓN SERA REDIRIGIDO AL INICIO
        window.location.href = '/';
      }
    }
    


    async getEspecialista(idPaciente) {

      try {
        
        const especialista = await this.__citasservice.getLastCita(idPaciente).then((res: any) => {
          this.nombreEspecialista = res.idEspecialista.nombre;
          this.idEspecialista = res.idEspecialista.$id;
          // console.log("nombreEspecialista:::",this.nombreEspecialista);
          // console.log("idEspecialista:::",this.idEspecialista);
          // console.log("CITA:::",res);
        });
      } catch (error) {
        //ERROR NO HAY ESPECIALISTA QUE LO HAYA ATENTIDO ANTES.
        // console.log("error tu especialista:::",error);
      }
    }
  }